import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { MultiFacilityModel } from 'src/app/post-login/services/multi-facility.model';
import { MultiFacilityService } from 'src/app/post-login/services/multi-facility.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { CustomizeBrandingService } from '../customize-branding.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalPopupComponent } from 'src/app/core/confirmation-modal-popup/confirmation-modal-popup.component';
import { VideoLibraryService } from '../../video-library.service';
import { Customization, ImageSize } from '../../video-library.model';
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {
  @ViewChild('titleTemplate') titleTemplate: TemplateRef<any>;
  @ViewChild('action') action: TemplateRef<any>;
  @ViewChild('facilitiesTemplate') facilitiesTemplate: TemplateRef<any>;
  @ViewChild("fileSE3") fileSE3 : ElementRef;
  @ViewChild("fileSE4") fileSE4 : ElementRef;
  @ViewChild(ConfirmationModalPopupComponent) modalComponent: ConfirmationModalPopupComponent;
  rootScopeData: RootScopeDeclare;
  filesSE3: any;
  filesSE4: any;
  cloudBasePath: string;
  selectedConsoleType = 'SE4';
  lastUpdateOn: string | undefined = '';
  lastUpdatedBy: string | undefined = '';
  isNonClickedOnDeleteButton = true;
  isAvailableSE3 = false;
  isAvailableSE4 = false;
  isEnabled = false;
  errorMessage = '';
  showFooter = false;
  isPublishModal = false;
  isDeleteModal = false;
  showDeleteConfirmationModal = false;
  showUnsavedModal = false;
  hasFullPermission = false;
  bannerForDelete = '';
  clickedOnChooseFile = '';
  fileNameSE3 = '';
  fileNameSE4 = '';
  oldFileNameSE3 = '';
  oldFileNameSE4 = '';
  shouldOpenUploadPopup = false;
  multiFacilities: MultiFacilityModel[];
  customizeData: Customization | any = {};
  imgSE3Url: string | undefined;
  imgSE4Url: string | undefined;
  selectedFacilities: string[] = [];
  isSE3BannerChange = false;
  isSE4BannerChange = false;
  bannerHeadline: string;
  bannerDescription: string;
  deletePopupProperties = {
    title: 'DELETE.CONFRIMATION.MODAL.TITLE',
    message: 'DELETE.CONFIRMATION.MODAL.TEXT',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
  };
  unSavedPopupProperties = {
    title: 'UNSAVED.CHANGES',
    message: 'UNSAVED.CHANGES.MESSAGE',
    isWarningPopup: true,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'NO',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
  };
  currentUrl: string;
  selectedSingleSiteFacility: string;
  facilitiesConsoleEquipmentsMap : any;
  facilityIds = [] as any;
  enabledEquipmentOnDemandNCustomLibrary = [] as any;
  zendeskUrl: string;
  private sub = new Subscription();
  @ViewChild('tooltipBanner', { static: false }) tooltipBanner: NgbTooltip;
  @ViewChild('tooltipDesc', { static: false }) tooltipDesc: NgbTooltip;
  constructor(
    private _commonUtil: CommonUtil,
    private _toast: HaloToastService,
    private _router: Router,
    private rootScopeService: RootScopeService,
    private _multiFacilityService: MultiFacilityService,
    private _facilityService: FacilityService,
    private _modal: HaloModalService,
    private _loader: HaloLoaderService,
    private _customizeBrandingService: CustomizeBrandingService,
    private _vdoLibraryService: VideoLibraryService
  ) {
    const routerSub = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (this._multiFacilityService.isMultifacilityUrl(event.url)) {
          this.currentUrl = event.url;
        }
      }
    });
    this.sub.add(routerSub);
  }

  async ngOnInit(){
    const dataSub = this._customizeBrandingService.customizeDataSubscriber.subscribe(data => {
      this.selectedConsoleType = 'SE4';
      this.showFooter = false;
      if (data) {
        this.errorMessage = '';
        if(data.data[0]) {
          this.customizeData = data.data[0].attributes;
        } else {
          this.customizeData = {};
          this.lastUpdateOn = '';
          this.lastUpdatedBy = '';
        }
        this.setLastUpdateData();
        this.filesSE3 = null;
        this.filesSE4 = null;
        this.fileNameSE3 = '';
        this.fileNameSE4 = '';
        this.oldFileNameSE3 = '';
        this.oldFileNameSE4 = '';
        this.isAvailableSE3 = false;
        this.isAvailableSE4 = false;
        this.imgSE3Url = '';
        this.imgSE4Url = '';
        this.bannerHeadline = this.customizeData.bannerHeadline ? 
                              this.customizeData.bannerHeadline : 
                              '';                                            
        this.bannerDescription = this.customizeData.bannerDescription ? 
                                  this.customizeData.bannerDescription : 
                                  '';
        this._checkAvailableConsoleType(this._facilityService.selectedFacility());
        if (this.customizeData.banner?.data && this.isAvailableSE3) {
          const img = this._vdoLibraryService.getAvailableImageFormat(this.customizeData.banner, ImageSize.MEDIUM);
          this.imgSE3Url = img?.url;
          this.customizeData.bannerName = this.customizeData?.banner?.data?.attributes?.name ?? img?.name;
        }
        if (this.customizeData.bannerSE4?.data && this.isAvailableSE4) {
          const img = this._vdoLibraryService.getAvailableImageFormat(this.customizeData.bannerSE4, ImageSize.MEDIUM);
          this.imgSE4Url = img?.url;
          this.customizeData.bannerSE4Name = this.customizeData?.bannerSE4?.data?.attributes?.name ?? img?.name;
        }
      }
    });
    this.sub.add(dataSub);

    const enableStatus = this._customizeBrandingService.isUpdateEnabledStatus$.subscribe(() => {
      this._checkAvailableConsoleType(this._facilityService.selectedFacility());
    })
    this.sub.add(enableStatus);

    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath; 
    
    const lfAssetApiResp = await this._facilityService.get();
    if(lfAssetApiResp){
      this.facilitiesConsoleEquipmentsMap = lfAssetApiResp.facilities;
    }

    this.zendeskUrl = 'https://lifefitness9512.zendesk.com/hc/en-us/articles/6916395280407';
  }

  getRootScopeData(): void {
    const getRpptScopeSub = this.rootScopeService
      .getRootScope()
      .subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
    this.sub.add(getRpptScopeSub);
  }

  setLastUpdateData(): void {
    const pairs = [
      {
        timeNumber: +new Date(this.customizeData.bannerHeadlineUpdatedOn),
        time:  this.customizeData.bannerHeadlineUpdatedOn,
        author: this.customizeData.bannerHeadlineUpdatedBy
      },
      {
        timeNumber: +new Date(this.customizeData.bannerDescriptionUpdatedOn),
        time:  this.customizeData.bannerDescriptionUpdatedOn,
        author: this.customizeData.bannerDescriptionUpdatedBy
      },
      {
        timeNumber: +new Date(this.customizeData.bannerSE4UpdatedOn),
        time:  this.customizeData.bannerSE4UpdatedOn,
        author: this.customizeData.bannerSE4UpdatedBy
      },
      {
        timeNumber: +new Date(this.customizeData.bannerUpdatedOn),
        time:  this.customizeData.bannerUpdatedOn,
        author: this.customizeData.bannerUpdatedBy
      },
    ]
    this.selectedConsoleType === 'SE3' ? pairs.splice(3,1) : pairs.splice(2,1);
    const minTime =  Math.max(...pairs.map(item => item.timeNumber).filter((time) => time !== 0));
    const pair = pairs.find(pair => pair.timeNumber === minTime);
    this.lastUpdatedBy = pair?.author;
    this.lastUpdateOn = pair?.time;
  
  }

  onBannerHeadlineChanged() {
    this.onEdit();
  }

  onDescriptionChanged() {
    this.onEdit();
  }

  onEdit() {
    this._commonUtil.rootScopeData.isPageHasUnsavedChanges = true;
    this.showFooter = true;
  }

  chooseFileClick(type: string): void {
    this.clickedOnChooseFile = type
    this.errorMessage = '';
    type === 'SE3' ? this.fileNameSE3 = '' :  this.fileNameSE4 = '';
  }

  triggerUploadFunctionality(event: any, type: string): void {
    if (type == 'SE3' && !this.isSE3BannerChange) {
      event.target.value = '';
    }

    if (type == 'SE4' && !this.isSE4BannerChange) {
      event.target.value = '';
    }
  }

  fileBrowseHandler(files: any, type: string): void {
    this.errorMessage = '';
    let width = 1426;
    let height = 287;
    if (type === 'SE3') {
      width = 1920;
      height = 500;
    }
    if (files) {
      this.validateSelectedFile(files[0], type);
      if (this.errorMessage) return;
      var reader = new FileReader();
      reader.onload = (event: any) => {
        var image = new Image();
        image.src = event.target.result;
        image.onload = () => {
          if (image.naturalHeight !== height || image.naturalWidth !== width) {
            this.errorMessage = this._commonUtil.translateText('IMAGE.DIMENSION.ERROR.MSG');
            if (!this.isSE4BannerChange && !this.isSE3BannerChange) {
              type === 'SE3' ? this.filesSE3 = undefined : this.filesSE4 = undefined;
              if(type === 'SE3') {
                this.fileNameSE3 = '';
                this.oldFileNameSE3 = '';
              } else {
                this.fileNameSE4 = '';
                this.oldFileNameSE4 = '';
              }
              this.showFooter = false;
            }
            if (this.customizeData.banner?.data && this.isAvailableSE3 && type === 'SE3') {
              const img = this._vdoLibraryService.getAvailableImageFormat(this.customizeData.banner, ImageSize.MEDIUM);
              this.imgSE3Url = img?.url;
            }
            if (this.customizeData.bannerSE4?.data && this.isAvailableSE4 && type === 'SE4') {
              const img = this._vdoLibraryService.getAvailableImageFormat(this.customizeData.bannerSE4, ImageSize.MEDIUM);
              this.imgSE4Url = img?.url;
            }
          } else {
            this.rootScopeData.isPageHasUnsavedChanges = true;
            type === 'SE3' ? this.filesSE3 = files : this.filesSE4 = files;
            type === 'SE3' ? this.fileNameSE3 = this.filesSE3[0].name : this.fileNameSE4 = this.filesSE4[0].name;
            type === 'SE3' ? this.oldFileNameSE3 = this.filesSE3[0].name : this.oldFileNameSE4 = this.filesSE4[0].name;
            type === 'SE3' ? this.isSE3BannerChange = true : this.isSE4BannerChange = true;
            this.showFooter = true;
             type === 'SE3' ? this.imgSE3Url = event.target.result : this.imgSE4Url = event.target.result;
             this.selectedConsoleType = type === 'SE3' ? 'SE3' : 'SE4';
          }
        };
      };
      reader.readAsDataURL(files[0]);
    }       
  }

  validateSelectedFile(file: File, type: string): void {
    var extensions = /(\.png|\.jpg|\.jpeg)$/i;
    if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') ||
      !extensions.exec(file.name)) {
      this.errorMessage = this._commonUtil.translateText('FILE.UPLOAD.FORMAT');
      if (!this.isSE4BannerChange && !this.isSE3BannerChange) {
        this.showFooter = false;
      }
    }
  }

  onDeleteFile(type: string): void {
    if (type === 'SE3') {
      if (this.isSE3BannerChange) {
        if (this.customizeData.banner?.data && this.isAvailableSE3) {
          const img = this._vdoLibraryService.getAvailableImageFormat(this.customizeData.banner, ImageSize.MEDIUM);
          this.imgSE3Url = img?.url;
        } else {
          this.imgSE3Url = undefined;
        }
        this.oldFileNameSE3 = '';
        this.fileNameSE3 = '';
        this.filesSE3 = null;
        this.isSE3BannerChange = false;
        if (!this.isSE4BannerChange) {
          this.showFooter = false;
        }
      } else {
        if (this.isNonClickedOnDeleteButton) {
          this.bannerForDelete = 'SE3';
          this.isDeleteModal = true;
          this.isPublishModal = false;
          this.showLFODVideoTree();
          this.isNonClickedOnDeleteButton = false;
        }
      }

    } else {
      if (this.isSE4BannerChange) {
        if (this.customizeData.bannerSE4?.data && this.isAvailableSE4) {
          const img = this._vdoLibraryService.getAvailableImageFormat(this.customizeData.bannerSE4, ImageSize.MEDIUM);
          this.imgSE4Url = img?.url;
        } else {
          this.imgSE4Url = undefined;
        }
        this.oldFileNameSE4 = '';
        this.fileNameSE4 = '';
        this.filesSE4 = null;
        this.isSE4BannerChange = false;
        if (!this.isSE3BannerChange) {
          this.showFooter = false;
        }
      } else {
        if (this.isNonClickedOnDeleteButton) {
          this.bannerForDelete = 'SE4';
          this.isDeleteModal = true;
          this.isPublishModal = false;
          this.showLFODVideoTree();
          this.isNonClickedOnDeleteButton = false;
        }
      }
    }
    this.errorMessage = '';
  }

  cancel(): void {
    this.rootScopeData.pathToNavigate = '/videoLibrary';
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
    }
    else {
      this.rootScopeData.isPageHasUnsavedChanges = false;
      this._router.navigate(['/videoLibrary']);
    }
  }

  next(): void {
    if (!this.isPublishModal) {
      this.isPublishModal = true;
      this.isDeleteModal = false;
      this.errorMessage = '';
      this.showLFODVideoTree();
    }
  }

  changeSelectedConsole(type: string): void {   
    if(type === this.selectedConsoleType) return;
    if ((type === 'SE3' && this._customizeBrandingService.isSe3LFODEnabledCount) || (type === 'SE4' && this._customizeBrandingService.isSe4LFODEnabledCount)) {
      this.errorMessage = '';
      this._changeSelectedConsole(type);
      this.setLastUpdateData();
    }
  }

  triggerUnsavedModal(): void {
    setTimeout(() => {         
      this.modalComponent.show(true).then(res => {
        if(res == 1) {
          this.confirmUnsavedModalCustomize();
        } else {
          this.showUnsavedModal = false;
          this.shouldOpenUploadPopup = false
        } 
      });
    });
  }

  cancelOnModal(): void {
    this._modal.close();
    this.isPublishModal = false;
    this.isDeleteModal = false;
    this.isNonClickedOnDeleteButton = true;
  }

  async confirmOnModal(type: string) {
    if (type === 'publish') {
      const formData = new FormData();      
      let facIds = this.selectedFacilities.map((id) => +id);
      let selectedFacId = Number(this._facilityService.selectedFacility().facilityId);
      facIds = facIds.filter(val => val !== selectedFacId);
      facIds.splice(0,0,selectedFacId);
      const data = JSON.stringify({
        bannerHeadline: !!this.bannerHeadline ? this.bannerHeadline: null,
        bannerDescription: !!this.bannerDescription ? this.bannerDescription : null,
        updatedBy: this.rootScopeData?.currentUser?.displayName,
        facilityIds: facIds,
      });
      formData.append('data', data);
      if (this.filesSE3 && this.filesSE3[0]) {
        formData.append('files.banner', this.filesSE3[0])
      }
      if (this.filesSE4 && this.filesSE4[0]) {
        formData.append('files.bannerSE4', this.filesSE4[0])
      }
      this.cancelOnModal();
      this._loader.startProcess();
      try {
        await this._customizeBrandingService.saveCustomize(formData);
        this.filesSE3 = null;
        this.filesSE4 = null;
        this.fileNameSE3 = '';
        this.fileNameSE4 = '';
        this.oldFileNameSE3 = '';
        this.oldFileNameSE4 = '';
        this.showFooter = false;
        this.isSE3BannerChange = false;
        this.isSE4BannerChange = false;
        this.isNonClickedOnDeleteButton = true;
        this._toast.creatToast(this._commonUtil.translateText('PUBLISHED.BANNER'));
        this.rootScopeData.isPageHasUnsavedChanges = false;
      } catch (error) {        
      }      
      this.showDeleteConfirmationModal = false;
      this._loader.endProcess();
    } else {
      this.showDeleteConfirmationModal = true;
    }
  }

  async  deleteModalConfirm() {
    const list = this.selectedFacilities.map((id) => +id);
    const payload = {
      [this.bannerForDelete === 'SE3' ? 'banner' : 'bannerSE4']: null,
      facilityIds: list,
    };
    this.cancelOnModal();
    this.showDeleteConfirmationModal = false;
    this._loader.startProcess();
    try {
      await this._customizeBrandingService.saveCustomize(payload);
      this.bannerForDelete === 'SE3' ? this.imgSE3Url = undefined : this.imgSE4Url = undefined;
      this.bannerForDelete === 'SE3' ? this.filesSE3 = null : this.filesSE4 = null;
      this.bannerForDelete === 'SE3' ? this.isSE3BannerChange = false : this.isSE4BannerChange = false;
      this.bannerForDelete = '';
      this.isNonClickedOnDeleteButton = true;
      this.rootScopeData.isPageHasUnsavedChanges = false;
      this._toast.creatToast(this._commonUtil.translateText('DELETE.BANNER.SUCCESS.MSG'));
    } catch (error) {        
    }
    this._loader.endProcess();
  }

  onSelectedFacilityChanged(value:any): void {
    let fac = value.map((val:any) => val.facilityId);
    this.isEnabled = fac.length > 0;
    this.selectedFacilities = fac;
  }

  async showLFODVideoTree() {
    this._loader.startProcess();
    try {
      let respMultiFacilities = await this._multiFacilityService.getMultiFacilities();
      let defaultFacilities:any;
      respMultiFacilities = this.filter(JSON.parse(JSON.stringify(respMultiFacilities)));
      defaultFacilities = this.selectDefault(respMultiFacilities);
      /* Start Here , Below code make facility check option to be disiabled based on the isLFODEnabledCount */
      this.facilityIds = [];
      let data = [] as any;
      this.getFacilityIds(defaultFacilities);     
      let tmp_1 = await this._vdoLibraryService.getEnabledOnDemandClasses(this.facilityIds).toPromise();
      let tmp_2 =  Object.entries(tmp_1) as any;
      let se4ConsolesTypes = ['hal','everest','neo_se4','falco'];
      tmp_2.forEach((ele:any) => {
        if(JSON.stringify(ele) !== "{}"){
          let eqStatus = Object.values(ele[1]) as any;      
          let obj = {
            "facilityId": ele[0],
            "isLFODEnabledCount": eqStatus.find((val:any) => val.lfodenabledCount>0)?true:false,
            "isSe4LFODEnabledCount": eqStatus.find((val:any) => se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
            "isSe3LFODEnabledCount": eqStatus.find((val:any) => !se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
            "isCustomLibraryEnabledCount" : eqStatus.find((val:any) => val.customLibraryEnabledCount>0)?true:false
          }   
          data.push(obj);
        }
      });

      this.enabledEquipmentOnDemandNCustomLibrary = data;
      this.multiFacilities = this.updateIsEnabledStatus(defaultFacilities);
      /* End Here */
      this._modal.add({
        dismissible: true,
        titleUppercase: true,
        modalSize: HaloModalSize.Medium,
        titleTemplate: this.titleTemplate,
        footerTemplate: this.action,
        bodyTemplate: this.facilitiesTemplate,
        isVideoTree: false,
      });
    } catch (error) {
      console.error('API failed.');
    }
    this._loader.endProcess();
  }

  async setEnabledOnDemandCounts(facilityId: any) {
    let data = [] as any;
    if(this.enabledEquipmentOnDemandNCustomLibrary && this.enabledEquipmentOnDemandNCustomLibrary.length == 0) {
      let tmp_1 = await this._vdoLibraryService.getEnabledOnDemandClasses(facilityId).toPromise();
      let tmp_2 =  Object.entries(tmp_1) as any;
      let se4ConsolesTypes = ['hal','everest','neo_se4','falco'];
      tmp_2.forEach((ele:any) => {
        if(JSON.stringify(ele) !== "{}"){
          let eqStatus = Object.values(ele[1]) as any;      
          let obj = {
            "facilityId": ele[0],
            "isLFODEnabledCount": eqStatus.find((val:any) => val.lfodenabledCount>0)?true:false,
            "isSe4LFODEnabledCount": eqStatus.find((val:any) => se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
            "isSe3LFODEnabledCount": eqStatus.find((val:any) => !se4ConsolesTypes.includes(val.consoleType) && val.lfodenabledCount>0)?true:false,
            "isCustomLibraryEnabledCount" : eqStatus.find((val:any) => val.customLibraryEnabledCount>0)?true:false
          };
          this._customizeBrandingService.isSe3LFODEnabledCount = obj.isSe3LFODEnabledCount;
          this._customizeBrandingService.isSe4LFODEnabledCount = obj.isSe4LFODEnabledCount;   
          this.selectedConsoleType = this._customizeBrandingService.isSe4LFODEnabledCount ? 'SE4' : this._customizeBrandingService.isSe3LFODEnabledCount ? 'SE3' : 'SE4';
          if(!this._customizeBrandingService.isSe3LFODEnabledCount && !this._customizeBrandingService.isSe4LFODEnabledCount) {
            this.selectedConsoleType = this.isAvailableSE4 ? 'SE4' : this.isAvailableSE3 ? 'SE3': ''
          }
          data.push(obj);
        }
      });
      this.enabledEquipmentOnDemandNCustomLibrary = data;
    }
  }

  updateIsEnabledStatus(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      let fac = this.facilitiesConsoleEquipmentsMap.find((fConsole : any) => fConsole.facilityId === facility.facilityId);
      let tmp = this.enabledEquipmentOnDemandNCustomLibrary.find((val:any) => val.facilityId === facility.facilityId);
      if(fac.summary.userRights.customLibrary === "F"){
        if(tmp && tmp.facilityId){
          if(tmp.isLFODEnabledCount === true){
            facility.isEnabled = true;
          }else{
            facility.isEnabled = false;
          }
        }
      }else{
        facility.isEnabled = false;
      }      
      this.updateIsEnabledStatus(facility.children);
    });
    return facilities;
  }

  getFacilityIds(facilities: MultiFacilityModel[]) {
    facilities?.forEach((fac) => {
      this.facilityIds.push(Number(fac.facilityId));
      this.getFacilityIds(fac.children);
    });
    return facilities;
  }

  filter(facilities: MultiFacilityModel[]) {
    let filteredFacs: MultiFacilityModel[] = [];
    facilities?.forEach((facility) => {
      facility.children = this.filter(facility.children);
      facility.isEnabled = this.isValidLFODSupportFacility(facility);
      if (facility.isEnabled || this.hasLFODEnabledChildren(facility)) {
        filteredFacs.push(facility);
      }
    });
    return filteredFacs;
  }

  hasLFODEnabledChildren(facModel: MultiFacilityModel) {
    if (!facModel || !facModel.children) return false;
    for (let child of facModel.children) {
      if (child?.isEnabled || this.hasLFODEnabledChildren(child)) return true;
    }
    return false;
  }

  isValidLFODSupportFacility(facilityData: MultiFacilityModel) {
    return facilityData
      ? this._multiFacilityService.isMultifacilitySupported(this.currentUrl ?? this._router.url, facilityData)
      : false;
  }

  selectDefault(facilities: MultiFacilityModel[]) {
    facilities?.forEach((facility) => {
      let selectedFacility = this._facilityService.selectedMultiFacilities();
      let isValidLFODSup = this.isValidLFODSupportFacility(facility);
      if (selectedFacility.findIndex((f) => f === facility.facilityId) > -1 && isValidLFODSup) {
        facility.isSelected = true;
        facility.isDisabledSelectedFacility = true;
        this.selectedSingleSiteFacility = facility.facilityId;
      } else {
        facility.isSelected = false;
        facility.isDisabledSelectedFacility = false;
      }
      let fac = this.facilitiesConsoleEquipmentsMap.find((fConsole : any) => fConsole.facilityId === facility.facilityId);
      if(fac.summary.userRights.customLibrary !== "F"){
        facility.isEnabled = false;
      }
      this.selectDefault(facility.children);
    });
    return facilities;
  }

  confirmUnsavedModalCustomize(): void {
    this._changeSelectedConsole(this.selectedConsoleType === 'SE3' ? 'SE4' : 'SE3');
  }

  private _changeSelectedConsole(type: string): void {
    this.selectedConsoleType = type;
  }

  private async _checkAvailableConsoleType(data: any): Promise<void> {
    if (data.consoleEquipments) {
      this.setEnabledOnDemandCounts([this._facilityService.selectedFacility().facilityId]);
      data.consoleEquipments.forEach((consoleItem: any) => {
        if (consoleItem.consoleType === 'superman' || consoleItem.consoleType === 'mulder') {
          this.isAvailableSE3 = true;
        }
        if (consoleItem.consoleType === 'hal' || consoleItem.consoleType === 'neo_se4' ||  consoleItem.consoleType ==='everest' || consoleItem.consoleType ==='falco') {
          this.isAvailableSE4 = true;
        }
      });

      const showSE3Preview = this.isAvailableSE3 && this._customizeBrandingService.isSe3LFODEnabledCount ||
       ( this.isAvailableSE3 && !this._customizeBrandingService.isSe3LFODEnabledCount && !this._customizeBrandingService.isSe4LFODEnabledCount) ||
       (this.isAvailableSE3 && !this.isAvailableSE4)

       this.selectedConsoleType = showSE3Preview ? 'SE3' : 'SE4'
    } else {
      this._commonUtil.redirectToAvailablePage();
    }
  }

  onPermissionChange(value:boolean){
    this.hasFullPermission = value;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
